import {
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
} from "reactstrap"

import classNames from "classnames"

import { useScenario } from "../contexts/ScenarioContext"

//import InterventionsStatus from "./tabs/InterventionsStatus"
import OPQRSTTabContent    from "./tabs/OPQRST"
import SampleTabContent    from "./tabs/SampleTab"
import VitalsTabContent    from "./tabs/VitalsTab"
import GeneralTabContent    from "./tabs/GeneralTab"
import AirwayTabContent    from "./tabs/AirwayTab"
import BreathingTabContent    from "./tabs/BreathingTab"
import CirculationTabContent    from "./tabs/CirculationTab"


const PatientStatus = ()  => {
    const { patientStatusTab, setPatientStatusTab } = useScenario()

    const activateTab = (tab) => {
        if (patientStatusTab !== tab) setPatientStatusTab(tab)
    }
    const isActiveTab = (tab) => tab === patientStatusTab

    return (
        <>
            <Nav tabs>
                <NavItem>
                    <NavLink
                        className={classNames({ active: isActiveTab('vitals') })}
                        onClick={() => activateTab('vitals')}
                    >
                        Vitals
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        className={classNames({ active: isActiveTab('sample') })}
                        onClick={() => activateTab('sample')}
                    >
                        SAMPLE
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        className={classNames({ active: isActiveTab('opqrst') })}
                        onClick={() => activateTab('opqrst')}
                    >
                        OPQRST
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        className={classNames({ active: isActiveTab('general') })}
                        onClick={() => activateTab('general')}
                    >
                        LOC
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        className={classNames({ active: isActiveTab('airway') })}
                        onClick={() => activateTab('airway')}
                    >
                        A
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        className={classNames({ active: isActiveTab('breathing') })}
                        onClick={() => activateTab('breathing')}
                    >
                        B
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink
                        className={classNames({ active: isActiveTab('circulation') })}
                        onClick={() => activateTab('circulation')}
                    >
                        C
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={patientStatusTab}>
                <TabPane tabId="vitals" >
                    <VitalsTabContent />
                </TabPane>
                <TabPane tabId="sample" >
                    <SampleTabContent />
                </TabPane >
                <TabPane tabId="opqrst">
                    <OPQRSTTabContent />
                </TabPane>
                <TabPane tabId="general">
                    <GeneralTabContent />
                </TabPane>
                <TabPane tabId="airway">
                    <AirwayTabContent />
                </TabPane>
                <TabPane tabId="breathing">
                    <BreathingTabContent />
                </TabPane>
                <TabPane tabId="circulation">
                    <CirculationTabContent />
                </TabPane>
            </TabContent>
        </>
    )
}

export default PatientStatus